import { Button, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';

const getPeriodLabel = (months: number): string => {
  if (months === 1) return '1 mês';
  if (months === 12) return '1 ano';
  return `${months} meses`;
};

export type RequestLimitDialogProps = {
  onClose: () => void;
  maxRefundsPerPeriod?: number;
  renewalPeriodInMonths?: number;
};

export const RequestLimitDialog = ({
  onClose,
  maxRefundsPerPeriod,
  renewalPeriodInMonths,
}: RequestLimitDialogProps) => {
  const navigate = useNavigate();
  const hasLimitInfo = maxRefundsPerPeriod && renewalPeriodInMonths;

  return (
    <BaseDialog
      open
      onClose={onClose}
      title="Você atingiu o limite de solicitações para o período."
      icon={<Icon name="hand-money" alt="Limite de solicitações atingido" />}
      actionsComponent={
        <Button onClick={onClose} variant="contained">
          Entendi
        </Button>
      }
    >
      <Typography sx={{ mb: 2 }}>
        {hasLimitInfo ? (
          <>
            Sua política permite solicitar até {maxRefundsPerPeriod}{' '}
            {maxRefundsPerPeriod === 1 ? 'reembolso' : 'reembolsos'} a cada{' '}
            {getPeriodLabel(renewalPeriodInMonths)}.{' '}
          </>
        ) : (
          <>
            Sua política possui limite de solicitações dentro de um período e
            você já atingiu o limite.{' '}
          </>
        )}
        <Link
          onClick={() => navigate('/meus-reembolsos/minhas-politicas')}
          sx={{ cursor: 'pointer', textDecoration: 'underline' }}
          color="primary.dark"
        >
          Revise as regras da política
        </Link>{' '}
        e faça uma nova solicitação em breve.
      </Typography>
    </BaseDialog>
  );
};
